export enum ApiError {
    ERROR_NETWORK = 'ERROR_NETWORK',
    UNAUTHORIZED = 'UNAUTHORIZED',
    TENANT_IS_NOT_ACTIVE = 'TENANT_IS_NOT_ACTIVE',
    INVALID_REQUEST_SCHEMA = 'INVALID_REQUEST_SCHEMA',
    INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
    ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND',
    ENTITY_ALREADY_EXISTS = 'ENTITY_ALREADY_EXISTS',
}
